export default __webpack_public_path__ + "static/media/PebbleIllustration_BikeRide.da6a9d33.png";